exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn-stage .read-only-shadow{position:absolute;left:0;right:0;top:0;bottom:0;margin:auto}.btn-stage{position:relative;display:inline-block}.btn-stage>a,.btn-stage>button,.btn-stage>input{width:100%}.btn-stage>a{cursor:pointer}.btn-stage .btn{position:relative}.btn-stage .btn .loading-stage{position:absolute;left:30px}.btn-stage .btn-value-show{display:inline-block}.btn-stage .read-only-shadow{background-color:#fff;opacity:0;cursor:not-allowed}.btn-stage.theme-primary .btn{padding:7px 15px}.btn-stage.m{padding:7px 30px}.btn-stage.l .btn{padding:7px 60px}.add_new .btn{width:150px;margin-left:15px;border:1px solid #e65454;background:none;color:#e65454}.add_new .btn:hover{border-color:#c9403f;color:#c9403f;background:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/components/base/btn/btn.scss
// module id = 565
// module chunks = 2